"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WriteQuery = void 0;
var WriteQuery = /** @class */ (function () {
    function WriteQuery(_a) {
        var dbModule = _a.dbModule, dbType = _a.dbType, dbCollection = _a.dbCollection, dbEndpoint = _a.dbEndpoint, dbAPIToken = _a.dbAPIToken, dbUserToken = _a.dbUserToken;
        var _this = this;
        this.dbType = "";
        this.dbCollection = "";
        this.call = function (queryType, queryData) { return __awaiter(_this, void 0, void 0, function () {
            var result, postBody, createResp, _a, err_1;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 10, , 11]);
                        result = true;
                        if (!(this.dbType === "mongoServer" ||
                            this.dbType === "fbServer" ||
                            this.dbType === "mondayServer")) return [3 /*break*/, 2];
                        postBody = {};
                        if (this.dbAPIToken)
                            postBody["apiToken"] = this.dbAPIToken;
                        if (this.dbUserToken)
                            postBody["userToken"] = this.dbUserToken;
                        if (queryData.unsetData)
                            postBody["unsetData"] = queryData.unsetData;
                        if (queryData.isOrQuery)
                            postBody["isOr"] = queryData.isOrQuery;
                        if (queryData.stopRes)
                            postBody["stopRes"] = queryData.stopRes;
                        if (queryData.unique)
                            postBody["unique"] = queryData.unique;
                        if (queryType === "create" ||
                            queryType === "batchCreate" ||
                            queryType === "update" ||
                            queryType === "batchUpdate") {
                            postBody["data"] = queryData.data;
                        }
                        if (queryType === "update" ||
                            queryType === "delete" ||
                            queryType === "batchDelete") {
                            postBody["id"] = queryData.id;
                        }
                        if (queryType === "batchDelete" || queryType === "batchUpdate") {
                            postBody["query"] = queryData.query;
                        }
                        return [4 /*yield*/, this.dbModule.post(this.dbEndpoint + "/".concat(this.dbCollection, "/").concat(queryType), postBody)];
                    case 1:
                        createResp = _d.sent();
                        result = (_c = (_b = createResp.data) === null || _b === void 0 ? void 0 : _b.success) !== null && _c !== void 0 ? _c : true;
                        return [3 /*break*/, 9];
                    case 2:
                        if (!(this.dbType === "firebase")) return [3 /*break*/, 9];
                        _a = queryType;
                        switch (_a) {
                            case "create": return [3 /*break*/, 3];
                            case "update": return [3 /*break*/, 5];
                            case "delete": return [3 /*break*/, 7];
                        }
                        return [3 /*break*/, 9];
                    case 3: return [4 /*yield*/, this.dbModule
                            .firestore()
                            .collection(this.dbCollection)
                            .doc(queryData.data["id"])
                            .set(queryData.data)];
                    case 4:
                        _d.sent();
                        return [3 /*break*/, 9];
                    case 5: return [4 /*yield*/, this.dbModule
                            .firestore()
                            .collection(this.dbCollection)
                            .doc(queryData.id)
                            .update(queryData.data)];
                    case 6:
                        _d.sent();
                        return [3 /*break*/, 9];
                    case 7: return [4 /*yield*/, this.dbModule
                            .firestore()
                            .collection(this.dbCollection)
                            .doc(queryData.id)
                            .delete()];
                    case 8:
                        _d.sent();
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/, result];
                    case 10:
                        err_1 = _d.sent();
                        throw err_1;
                    case 11: return [2 /*return*/];
                }
            });
        }); };
        this.dbModule = dbModule;
        this.dbType = dbType;
        this.dbCollection = dbCollection;
        this.dbEndpoint = dbEndpoint;
        this.dbAPIToken = dbAPIToken;
        this.dbUserToken = dbUserToken;
    }
    return WriteQuery;
}());
exports.WriteQuery = WriteQuery;
//# sourceMappingURL=index.js.map